import React, { useEffect, useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import ProjectImg from "../assets/Img/projectImg.jpg";
import axios from "axios";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";
import { useLocation } from "react-router-dom";

const Project = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
const [key,setKey] = useState(Math.random().toString())
const {pathname} = useLocation()
  useEffect(() => {
    const fetchData = () => {
    
      axios
        .get(
          `${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/all/project`
        )
        .then((res) => {

          setData(res.data.data);
         
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchData();
    window.scrollTo(0, 0);
  }, []);
useEffect(() => {
    setKey(Math.random().toString())


    const handleLoading = async () => {
      setLoading(true); // Start loading
      window.scrollTo(0, 0);

      // Simulate loading for demonstration purposes
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setLoading(false); // Stop loading
    };

    handleLoading();
  }, [pathname]);
  return (
    <React.Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            ariaLabel="loading-content"
          />
        </div>
      ) : (
        <div>
          <HeaderMobile />
          <Breadcrumb heading={"Projects"} bTitle={"Projects"} />
          <Container>
            <Row className="galleryRow ">
              
              {data &&
                data.map((item) => (
                  <React.Fragment key={item._id}>
                    
                    <Col lg={12}>
                      <Card className="projectCard">
                        <p
                          dangerouslySetInnerHTML={{
                            __html: `<style>img { width: auto; }</style> ${item.Description}`,
                          }}
                        />
                      </Card>
                    </Col>
                  </React.Fragment>
                ))}
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  );
};

export default Project;
